import React, { useEffect, useState } from 'react';

// import { Inventory } from "../../Inventory/Inventory";

import UserProvider from "../../../UserProvider";

import { BsHourglassSplit } from "react-icons/bs";








import { Loading } from "../../Shared";


import { getDeliverApplications } from "../data/deliver-data";
import { ActionButton, BaseButton, Button, Dropdown, Icon, IDropdownOption, Link, Panel, PanelType, Shimmer, TextField } from "office-ui-fabric-react";
import { Ws360Wheel } from "../components/360Wheel/360Wheel";




import logoImage from '../../../images/three-sixty-image/AvanadeLogo.png';
import { threeSixtyData } from "../components/360Wheel/ThreeSixtyDataApps";
import { WsWheelItem, WsWheelRecharts } from "./WheelRecharts";








// import { PrimeReactProvider } from 'primereact/context';

import { WsAppsPackages } from "./AppsPackages";


import ReactApexChart from "react-apexcharts";







import './Page.scss';

import './Apps.scss';
import { getItemFieldValue, WsDeliverApp } from "../apps-core";
import { apiGet, apiPost } from "../../../helpers-sales";



























// const applications = getDeliverApplications();






const packagingStatus: any = {
  'Docker_DockerDesktop_4.49.0_x64_R1': 3,
  'Eclipse_JDK_11.0.29.7_x64_R1': 4,
  'Eclipse_JDK_21.0_x64_R1': 4,
  'Google_Chrome_142.0.7444.60_x64_R1': 3,
  'IgorPavlov_7Zip_24.09.00.0_x64_R1': 3,
  'MartinPrikryl_WinSCP_6.3_x86_R1': 3,
  'Microsoft_PowerBIDesktop_2.147.1085.0_x64_R1': 3,
  'Microsoft_VisualStudioCode_1.106_x64_R1': 3,
  'Mozilla_Firefox_144.0.2_x64_R1': 4,
  'Oracle_SqlDeveloper_24.3.1.347_x64_R1': 3,
  'Rancher_RancherDesktop_1.20.1_X64_R1': 3,
  // '7-Zip File Manager': 5,
  // 'Access 2010': 1,
  // 'Access for Business Objects': 6,
  // 'Ace 7_0': 1,
  // 'Ace-DevTest 7_0': 1,
  // 'Ace-QA 7_0': 1,
  // 'Ace-RepairsDM 7_0': 1,
  // 'AceIMACS 7_0': 1,
  // 'Acqua Data Studio': 4,

  // 'Acrobate Reader 7': 2,

  // 'Active Directory Users Computers': 3,

  // 'AD Password Reset': 2,

  // 'Adobe': 1,
  // 'Adobe 7': 2,

  // 'Adobe Acrobat': 4,

  // 'Adobe Acrobat Reader 11.0.10': 3,

  // 'Adobe Acrobat reader 7.0': 2,

  // 'Adobe Acrobat Reader XI': 2,

  // 'Adobe Flash player active X 10': 4,

  // 'Adobe SVG Viewer 3.0': 7,

  // 'Angry IP': 3,

  // 'Aptos': 5,
  // 'Aptos-OneTel UK CGA': 4,

  // 'ATLAS': 4,

  // 'Attachmate 6.5': 2,

  // 'Avaya CMS Supervisor / apps': 5,

  // 'Business Object': 2,

  // 'Business Object 6_5': 2,

  // 'Business Objects': 2,

  // 'Business Objects 12.3': 3,
};




const WsPackagingStatus = (props: { application: WsDeliverApp, name: string, status: any }) => {

  // const status: any = packagingStatus[props.name];

  const status = props.application.fields.stage ? props.application.fields.stage : 1;

  if (status) {

    if (status === props.status) {

      return (<div className="ws-packaging-in-progress"><BsHourglassSplit /></div>);

      // return (<Icon className="ws-application-status ws-action-test-running" iconName={'Running'} />);
      // return (<Icon className="ws-application-status ws-action-not-test" iconName={'SkypeCircleCheck'} />);

    } else if (status > props.status) {

      return (<Icon className="ws-application-status ws-ready-by-default" iconName={'SkypeCircleCheck'} />);
      // return (<Icon className="ws-application-status ws-ready-by-default" iconName={'SkypeCheck'} />);

    } else {
      return (<></>);
    }

  } else if (props.status === 1) {

    return (<div className="ws-packaging-in-progress"><BsHourglassSplit /></div>);

  } else {
    return (<></>);
  }
};







const data: WsWheelItem[] = [
  // { name: 'Discovery',   value: 100 },
  { name: 'Readiness',   value: 100, score: 10 },
  { name: 'Packaging',   value: 100, score: 10 },
  // { name: 'Remediation', value: 100 },
  { name: 'UAT',         value: 100, score: 10 },
  // { name: 'Deployment',  value: 100 }
];




const dataLevel2: WsWheelItem[][] = [

  [
    { name: 'Discovery', value: 100, score: 10 },
    { name: 'PRF Creation', value: 100, score: 10 }
  ],

  [
    { name: 'Application\nPackaging', value: 100, score: 10 },
    { name: 'Application\nRemediation', value: 100, score: 10 },
    { name: 'Deployment\nGroup\nCreation', value: 100, score: 10 },
    { name: 'Testing', value: 100, score: 10 }
  ],

  [
    { name: 'UAT\nScheduling', value: 100, score: 10 },
    { name : 'UAT\nTesting\nSupport', value: 100, score: 10 },
    {name: 'UAT\nSign off', value: 100, score: 10}
  ]

  // [
  //   { name: 'First Contact\nResolution',             value: 100 },
  //   { name: 'Mean Time\nTo Resolve',                 value: 100 },
  //   { name: 'Proactive\nResolution (%)',             value: 100 },
  //   { name : 'Service\nRequests\nAutomated (%)',      value: 100 },
  //   { name : 'Ticket\nAvoidance',                     value: 100 }
  // ],

  // [
  //   { name: '\nUptime\n',                                    value: 100 },
  //   { name: 'Device\nStartup\nTime',                         value: 100 },
  //   { name: 'Device\nExperience\nScore',                     value: 100 },
  //   { name : 'Prod & Collab\nApplication\nExperience Score', value: 100}
  // ],

  // [
  //   { name: 'Technology\nAdoption',                     value: 100 },
  //   { name: 'Digital\nChannel\nAdoption',               value: 100 },
  //   { name: 'Accessible\nFeature\nUsage',               value: 100 }
  // ],

  // [
  //   { name: 'DWP Net\nPromoter Score',                                    value: 100 },
  //   { name: 'Likes',                         value: 100 },
  //   { name: 'Star Rating',                     value: 100 },
  //   { name: 'Sentiment\nFeedback', value: 100},
  //   { name: 'Engagement\nFeedback', value: 100 }
  // ],

  // [
  //   { name: 'Quality\nIdeas\nGenerated',                                    value: 100 },
  //   { name: 'Ideas\nExperimented\nPrototyped',                         value: 100 },
  //   { name: 'GenAI & Automation\nStory Point\nVelocity',                     value: 100 },
  //   { name : 'Value\nRealised (ROI)', value: 100}
  // ]

];





const WsAppsPage = (props: any) => {

  const [ tab, setTab ] = useState<string>('dashboard');

  const [ panel, setPanel ] = useState<WsDeliverApp | null>(null);

  const [ apps, setApps ] = useState<WsDeliverApp[] | null>(null);



  const loadApps = async () => {
  
    const result = await apiGet(`/deliver/apps`);

    if (result && Array.isArray(result)) {

      const resultSorted = result.sort((a, b) => {  
                        if (`${a.fields.name}`.toLowerCase() > `${b.fields.name}`.toLowerCase()) return  1;
                        if (`${a.fields.name}`.toLowerCase() < `${b.fields.name}`.toLowerCase()) return -1;
                        return 0;
                      });

      setApps(resultSorted);
    }
  };



  useEffect(() => {
    loadApps();
  },[]);



  useEffect(() => {
    loadApps();
  },[ tab ]);



  if (apps) {

    return (
      <div className="ws-deliver-page ws-deliver-apps-page">

        <div className="ws-deliver-page-header">

          <div className="tabs is-medium is-boxed">
            <ul>
              <li className="ws-deliver-apps-page-title">
                <h1>
                  Apps
                </h1>
              </li>

              <li className={ tab === 'dashboard'     ? 'is-active' : '' }><a onClick={() => { setTab('dashboard')     }}>Dashboard</a></li>
              {/* <li className={ tab === 'triage'        ? 'is-active' : '' }><a onClick={() => { setTab('triage')        }}>Triage</a></li>
              <li className={ tab === 'value-tracker' ? 'is-active' : '' }><a onClick={() => { setTab('value-tracker') }}>Value Tracker</a></li>
              <li className={ tab === 'service'       ? 'is-active' : '' }><a onClick={() => { setTab('service')       }}>Service</a></li> */}
              <li className={ tab === 'migration'      ? 'is-active' : '' }><a onClick={() => { setTab('migration')      }}>Migration</a></li>
              <li className={ tab === 'admin'         ? 'is-active' : '' }><a onClick={() => { setTab('admin')         }}>Admin</a></li>

              {/* <li className={ tab === 'servicing' ? 'is-active' : ''         }><a onClick={() => { setTab('servicing') }}>Servicing</a></li>
              <li className={ tab === 'impact-assessment' ? 'is-active' : '' }><a onClick={() => { setTab('impact-assessment') }}>Impact Assessment</a></li>
              <li className={ tab === 'readiness' ? 'is-active' : ''         }><a onClick={() => { setTab('readiness') }}>Readiness</a></li>
              <li className={ tab === 'inventory' ? 'is-active' : ''         }><a onClick={() => { setTab('inventory') }}>Inventory</a></li> */}
            </ul>
          </div>

        </div>

        <div className="ws-deliver-apps-page-content">
          <UserProvider>

            {
              tab === 'dashboard'
              &&
              <>
                {/* <table className="table is-hoverable is-fullwidth ws-deliver-apps-stage-table">
                  <thead>
                    <tr>
                      <th>Application</th>
                      <th>Discovery</th>
                      <th>Readiness</th>
                      <th>Packaging</th>
                      <th>Remediation</th>
                      <th>UAT</th>
                      <th>Deployment</th>
                    </tr>
                  </thead>

                  <tbody>
                    {
                      applications.map((application) => {
                        return (
                          <tr key={`ws-application-${application.name}`}>
                            <td>{application.name}</td>
                            <td><WsPackagingStatus name={application.name} status={1} /></td>
                            <td><WsPackagingStatus name={application.name} status={2} /></td>
                            <td><WsPackagingStatus name={application.name} status={3} /></td>
                            <td><WsPackagingStatus name={application.name} status={4} /></td>
                            <td><WsPackagingStatus name={application.name} status={5} /></td>
                            <td><WsPackagingStatus name={application.name} status={6} /></td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table> */}

                <div className="ws-deliver-apps-page-actions">
                  <ActionButton
                    iconProps={{ iconName: 'Add' }}
                    onClick={async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {

                      const result = await apiPost(`/deliver/apps`, { name: '', fields: { name : 'New App' } });

                      if (result) {
                        console.log(result);
                        loadApps();
                      }
                    }}
                  >Create New App</ActionButton>
                </div>

                <div className="ws-deliver-apps-page-bar">
                  <WsAppsBarChart
                    legendVisible={true}
                    stage1={getAppCount(apps, undefined) + getAppCount(apps, 1)}
                    stage2={getAppCount(apps, 2)}
                    stage3={getAppCount(apps, 3)}
                    stage4={getAppCount(apps, 4)}
                    stage5={getAppCount(apps, 5)}
                    stage6={getAppCount(apps, 6)}
                    stage7={getAppCount(apps, 7)}
                  />
                </div>

                <table className="table is-hoverable is-fullwidth ws-deliver-apps-stage-table">
                  <thead>
                    <tr>
                      <th>Application</th>
                      <th>Discovery</th>
                      <th>Readiness</th>
                      <th>Migration</th>
                      <th>Remediation</th>
                      <th>UAT</th>
                      <th>Deployment</th>
                    </tr>
                  </thead>

                  <tbody>
                    {
                      apps.map((application) => {
                        return (
                          <tr key={`ws-application-${application.fields.name}`}>
                            <td>
                              <Link onClick={() => {
                                setPanel(application);
                              }}>{application.fields.name || 'App' }</Link>
                            </td>
                            <td><WsPackagingStatus application={application} name={application.fields.name} status={1} /></td>
                            <td><WsPackagingStatus application={application} name={application.fields.name} status={2} /></td>
                            <td><WsPackagingStatus application={application} name={application.fields.name} status={3} /></td>
                            <td><WsPackagingStatus application={application} name={application.fields.name} status={4} /></td>
                            <td><WsPackagingStatus application={application} name={application.fields.name} status={5} /></td>
                            <td><WsPackagingStatus application={application} name={application.fields.name} status={6} /></td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </>
            }

            {
              tab === 'migration'
              &&
              <>
                <WsAppsPackages
                  apps={apps}
                  loadApps={loadApps}
                  panel={panel}
                  setPanel={setPanel}
                />
              </>
            }

            {
              tab === 'admin'
              &&
              <>
                <br />
                <Shimmer />
                <br />
                <Shimmer width="80%" />
                <br />
                <Shimmer width="60%" />
                <br />
                <Shimmer width="40%" />
                <br />
                <br />
                <br />
              </>
            }

          </UserProvider>
        </div>
        {
          panel
          &&
          <WsAppPanel
            loadApps={loadApps}
            panel={panel}
            setPanel={setPanel}
          />
        }
      </div>
    );

  } else {
    return (
      <>
      <Loading/>
      </>
    );
  }
};












type WsAppPanelProps = {
  panel: WsDeliverApp;
  setPanel: React.Dispatch<React.SetStateAction<WsDeliverApp | null>>;
  loadApps: () => Promise<void>;
};

const WsAppPanel = (props: WsAppPanelProps) => {

  const [ editMode, setEditMode ] = useState<boolean>(false);

  const [ isLoading, setIsLoading ] = useState<boolean>(false);

  const [ app, setApp ] = useState<WsDeliverApp>({ ...props.panel });



  useEffect(() => {

    setEditMode(false);

    setIsLoading(false);

    setApp({ ...props.panel });

  }, [ props.panel ]);



  return (
    <>
      <Panel
        className="ws-deliver-apps-packages-panel"
        customWidth="500px"
        isBlocking={false}
        isOpen={true}
        onDismiss={() => {
          props.setPanel(null);
        }}
        type={PanelType.custom}
      >
        <h2 className="title is-4">{app.fields.name || '-'}</h2>

        <div className="ws-deliver-apps-packages-panel-actions">

          <div className="ws-deliver-apps-packages-panel-actions-left">
            {
              app.fields.status === 'RUNNING'
              &&
              <>
                <ActionButton
                  label="Stop"
                  iconProps={{ iconName: 'Stop' }}
                  onClick={async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {

                    app.fields.status = '';
                    
                    const result = await apiPost(`/deliver/apps/${app.id}`, app);

                    if (result) {
                      console.log(result);
                      props.loadApps();
                    }

                  }}
                >
                  Stop
                </ActionButton>
              </>
            }
          </div>

          <div className="ws-deliver-apps-packages-panel-actions-right">
            {
              editMode
              ?
              <>
                <ActionButton
                  label="Save"
                  iconProps={{ iconName: 'Save' }}
                  onClick={async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
                    setIsLoading(true);

                    const result = await apiPost(`/deliver/apps/${app.id}`, app);

                    if (result) {
                      console.log(result);
                      props.loadApps();
                    }

                    setEditMode(false);
                  }}
                >
                  Save
                </ActionButton>
              </>
              :
              <>
                <ActionButton
                  label="Edit"
                  iconProps={{ iconName: 'Edit' }}
                  onClick={async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
                    setEditMode(true);
                  }}
                >
                  Edit
                </ActionButton>
              </>
            }
          </div>

        </div>

        <div>

          {
            editMode
            ?
            <>
              <Dropdown
                label={`Stage:`}
                options={[
                  { key: 1, text: 'Discovery' },
                  { key: 2, text: 'Readiness' },
                  { key: 3, text: 'Migration' },
                  { key: 4, text: 'Remediation' },
                  { key: 5, text: 'UAT' },
                  { key: 6, text: 'Deployment' },
                  { key: 7, text: 'Complete' }
                ]}
                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {
                    setApp((prev) => {

                      const next = { ...prev };

                      next.fields['stage'] = Number(`${option.key}`);

                      return next;
                    });
                  }
                }}
                placeholder="Select Customer"
                selectedKey={Number(app.fields['stage']) || 1}
                styles={{
                  dropdown: { width: 340 }
                }}
              />
              <br />
            </>
            :
            <>
            <div className="ws-deliver-apps-packages-panel-field">
              <b>Stage:</b><br />
              {getStageName(app.fields.stage)}
            </div>
            <br />
            </>
          }

          <WsField editMode={editMode} setApp={setApp}  item={app} field="name" label="name" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="applicationName" label="application Name" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="path" label="path" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="sourcePath" label="source Path" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="installCommand" label="install Command" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="uninstallCommand" label="uninstall Command" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="installContext" label="install Context" />



          <WsField editMode={editMode} setApp={setApp}  item={app} field="detectionAppExist" label="detection App Exist" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="detectionFileExist" label="detection File Exist" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="detectionRegistryKeyPath" label="detection Registry Key Path" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="detectionRegistryValueName" label="detection Registry Value Name" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="detectionRegistryStringComparison" label="detection Registry String Comparison" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="detectionScriptPath" label="detection Script Path" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="vendorName" label="vendor Name" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="applicationVersion" label="application Version" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="description" label="description" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="notes" label="notes" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="iconPath" label="icon Path" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="developer" label="developer" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="owner" label="owner" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="intent" label="intent" />

          <WsField editMode={editMode} setApp={setApp}  item={app} field="assignmentGroupId" label="assignment Group Id" />

        </div>

        {/* <table className="table is-fullwidth">
          <thead>
            <tr>
              <th>Name</th>
              <th>Version</th>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table> */}
      </Panel>
    </>
  );
};










const WsField = (props: { setApp: React.Dispatch<React.SetStateAction<WsDeliverApp>>, editMode: boolean, item: WsDeliverApp, field: string, label: string }) => {
  return (
    <>
      <div className="ws-deliver-apps-packages-panel-field">
        <b style={{ textTransform: 'capitalize' }}>{props.label}</b>:<br />
        
        {
          props.editMode
          ?
          <>
            <TextField
              // label={prpps}
              // underlined
              placeholder="Enter Value"
              onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {

                // props.setApp((prev) => {



                //   const next = { ...prev };

                //   if (newValue) {
                //     next.fields[props.field] = newValue;
                //   } else {
                //     next.fields[props.field] = '';
                //   }

                //   return next;
                // });


                console.log(newValue);

                const next = { ...props.item};

                if (newValue) {
                  next.fields[props.field] = newValue;
                } else {
                  next.fields[props.field] = '';
                }

                props.setApp(next);

              }}
              value={getItemFieldValue(props.item.fields, props.field)}
            />
          </>
          :
          <>
            {getItemFieldValue(props.item.fields, props.field) || '-'}
          </>
        }
      </div>
      <br />
    </>
  );
};









const getStageName = (stage: number | undefined) => {

  if (stage === 1) {

    return 'Discovery';

  } else if (stage === 2) {

    return 'Readiness';

    } else if (stage === 3) {

    return 'Migration';

    } else if (stage === 4) {

    return 'Remediation';

    } else if (stage === 5) {

    return 'UAT';

    } else if (stage === 6) {

    return 'Deployment';

  } else if (stage === 7) {

    return 'Complete';

  } else {
    return 'Discovery';
  }
};


































const WsAppsBarChart = (props: {
  legendVisible: boolean;
  // mode:          string;
  // workloadName:  string;
  stage1:      number;
  stage2:   number;
  stage3:   number;
  stage4:  number;
  stage5:  number;
  stage6:  number;
  stage7:  number;
  // setResourcePanelVisible: React.Dispatch<React.SetStateAction<string>>;
  // workload: WsDeliverConfigWorkload;
  // workloadDataList:  WsWorkloadData[];
  // staticMappingList: WsDeliverConfigSchemaMapping[];
}) => {

  const [ resourcePanelVisible, setResourcePanelVisible ] = useState<string>('');

  const onClickSeries = (seriesIndex: number) => {
    if (seriesIndex === 0) {
      console.log('managed clicked');
      setResourcePanelVisible('MANAGED');
    } else {
      console.log('unmanaged clicked');
      setResourcePanelVisible('UNMANAGED');
    }
  };

  const countTotal = props.stage1 + props.stage2 + props.stage3 + props.stage4 + props.stage5 + props.stage6 + props.stage7;

  const options: ApexCharts.ApexOptions = {

    // title: {
    //   text: 'Resources'
    // },

    legend: {
      show: props.legendVisible,
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40,
      fontSize: '16px'
    },

    colors: [
      '#888888', // ignore
      '#671E75', // total
      '#E57200', // migration
      '#B19F16', // remediation
      '#007096', // uat
      '#0018A8', // read only
      '#00A82D', // read only
    ],

    chart: {
      type: 'bar',
      // height: 350,
      stacked: true,
      toolbar: {
        show: false
      },
      events: {
        dataPointSelection: function(event, chartContext, config) {
          // The 'config' object contains the selected data

          onClickSeries(config.seriesIndex);

          // console.log(chartContext);
          // console.log(config.seriesIndex);

          // console.log('Clicked on bar:', config.w.config.series[config.seriesIndex].data[config.dataPointIndex]);

          // alert('Bar clicked: ' + config.w.config.series[config.seriesIndex].data[config.dataPointIndex]);
        }
      }
    },

    dataLabels: {
      style: {
        fontSize: '16px',
        // fontWeight: 800
      }
    },

    plotOptions: {
      bar: {
        horizontal: true
      },
    },

    stroke: {
      width: 1,
      colors: [ '#fff' ]
    },

    xaxis: {
      categories: [ `` ],
      min: 0,
      max: countTotal > 0 ? countTotal : 100,
      tickAmount: 5
    },

    yaxis: {
      title: {
        text: undefined
      },
      axisTicks: {
        show: false
      }
    },

    fill: {
      opacity: 1
    }
  };

  const series: any  = [
    // {
    //   name: 'Total',
    //   group: 'total',
    //   data: [
    //     100
    //   ]
    // },
    {
      name: 'Discovery',
      // group: 'split',
      data: [
        props.stage1
      ]
    },
    {
      name: 'Readiness',
      // group: 'split',
      data: [
        props.stage2
      ]
    // }, {
    //   name: 'In Review (PowerShell)',
    //   // group: 'split',
    //   data: [
    //     props.countReview
    //   ]
    }, {
      name: 'Migration',
      // group: 'split',
      data: [
        props.stage3
      ]

      }, {
      name: 'Remediation',
      // group: 'split',
      data: [
        props.stage4
      ]

      }, {
      name: 'UAT',
      // group: 'split',
      data: [
        props.stage5
      ]

      }, {
      name: 'Deployment',
      // group: 'split',
      data: [
        props.stage6
      ]

      }, {
      name: 'Complete',
      // group: 'split',
      data: [
        props.stage7
      ]

      // }, {
      // name: 'Migration',
      // // group: 'split',
      // data: [
      //   props.stage3
      // ]
    }
  ];

  return (
    <>
      <ReactApexChart
        series={series}
        options={options}
        type="bar"
        height={145}
      />
    </>
  );
};





const getAppCount = (apps: WsDeliverApp[], stage: number | undefined) => {

  const appsInStage = apps.filter((app) => app.fields.stage === stage);

  return appsInStage.length;
};






export {
  WsAppsPage
};
